/* tl-site.js
   Moved out of the theme setting Custom HTML head on 13 Sep 2026, loaded with
   defer from snippets/tl-global-css.liquid. All three blocks already wait for
   DOMContentLoaded or check readyState, so deferring is safe.
   Edit here, not in the theme editor. */

/* ---- description-br-unbreak ---- */
/* Collection and page descriptions contain hard <br> tags left by the rich
   text editor (they carry data-mce-fragment). On Hip + Joint one sits after
   "of natural", which stranded a two-word line no matter how the measure was
   set - that is why capping the measure alone did not fix it.

   CSS cannot fix this: the br has no whitespace on either side, so hiding it
   joins "natural" and "ingredients" into one word. The break has to be
   replaced with a real space, which means touching the DOM.

   Scoped to description blocks only, so deliberate line breaks elsewhere (the
   address on the contact page, for one) are left alone.

   The permanent fix is deleting those <br> tags from the collection
   descriptions in admin. They are product data shared with the live site, so
   they are not edited from here. */
(function(){
  function unbreak(){
    document.querySelectorAll('.pagetitle + .rte br, .majortitle + .rte br')
      .forEach(function(br){
        var prev = br.previousSibling, next = br.nextSibling;
        var endsSpace   = prev && /\s$/.test(prev.textContent || '');
        var startsSpace = next && /^\s/.test(next.textContent || '');
        br.parentNode.replaceChild(
          document.createTextNode(endsSpace || startsSpace ? '' : ' '), br);
      });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', unbreak);
  } else { unbreak(); }
})();

/* Newsletter confirmation. See the .tl-toast note in the stylesheet above:
   the footer form's success message is real but lands below the fold on a
   page that has just scrolled to the top. */
(function(){
  function toast(){
    try{
      if (!/[?&]customer_posted=true/.test(window.location.search)) return;

      // Reuse the theme's own wording so there is one source of truth.
      var src = document.querySelector('.signup-form__response--success');
      var msg = src ? (src.textContent || '').replace(/\s+/g,' ').trim() : '';
      if (!msg) msg = 'Thank you for subscribing.';

      var el = document.createElement('div');
      el.className = 'tl-toast';
      el.setAttribute('role','status');
      el.setAttribute('aria-live','polite');
      var span = document.createElement('span');
      span.textContent = msg;
      var btn = document.createElement('button');
      btn.className = 'tl-toast__x';
      btn.type = 'button';
      btn.setAttribute('aria-label','Dismiss');
      btn.textContent = '\u00d7';
      btn.addEventListener('click', function(){ el.remove(); });
      el.appendChild(span); el.appendChild(btn);
      document.body.appendChild(el);

      // Drop the parameter so a refresh does not replay the message.
      if (window.history && window.history.replaceState){
        var u = new URL(window.location.href);
        u.searchParams.delete('customer_posted');
        window.history.replaceState({}, '', u.pathname + u.search + u.hash);
      }
      setTimeout(function(){ if (el.parentNode) el.remove(); }, 9000);
    }catch(e){}
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', toast);
  } else { toast(); }
})();

/* Two DOM-time fixes that cannot be done in Liquid.

   1. related-products renders an empty wrapper and injects its contents by
      AJAX, so its h4 exists only in the JS DOM. It is not in the server HTML
      for crawlers either way, which makes script the only layer where the
      level can be corrected.
   2. Judge.me's empty state gets a class so it can be styled without
      guessing at vendor markup.

   Runs on DOM ready, not in head: document.body is null while the head is
   parsing, and observing null silently does nothing. */
(function(){
  function fixHeading(){
    document.querySelectorAll('.section-related-products h4, .related-products h4').forEach(function(h4){
      var h2 = document.createElement('h2');
      h2.className = h4.className;
      h2.innerHTML = h4.innerHTML;
      h4.parentNode.replaceChild(h2, h4);
    });
  }
  function markEmptyReviews(){
    // This product template renders TWO Judge.me widgets, in different
    // sections, and they do not finish loading together. Deciding per widget
    // meant one could be briefly empty while the other already had reviews,
    // so the "no reviews yet" line was planted on a product with thirty of
    // them and never taken away again.
    //
    // Decided for the page as a whole instead, and re-decided on every run,
    // so a late-loading widget corrects it rather than leaving it wrong.
    var widgets = [].slice.call(document.querySelectorAll('.jdgm-widget.jdgm-review-widget'));
    if (!widgets.length) return;

    var anyReviews = false, anyLoading = false, emptySection = null;

    widgets.forEach(function(w){
      var sec = w.closest('.shopify-section') || w.parentElement;
      if (!sec) return;
      // Judge.me's revamped widget names review cards .jm-review-item. The
      // first version of this guessed four other names, matched none of
      // them, and so styled a widget with five reviews as if it were empty.
      // Broad attribute match now, so a rename does not silently break it.
      var hasReviews = w.querySelector('[class*="review-item"], [class*="jdgm-rev-"], .jdgm-rev, [data-review-id]');
      var loading = w.querySelector('.jm-loading-overlay [class*="skeleton"], .jdgm-spinner');
      if (hasReviews) anyReviews = true;
      if (loading) anyLoading = true;
      if (hasReviews || loading) { sec.classList.remove('tl-jm-empty'); return; }
      if (w.offsetHeight > 0) { sec.classList.add('tl-jm-empty'); emptySection = sec; }
    });

    var more = document.querySelector('.tl-jm-more');

    if (anyReviews || anyLoading || !emptySection) {
      if (more) more.parentNode.removeChild(more);
      return;
    }

    // A product with no reviews is a dead end: nothing to read, and no hint
    // that a few dozen reviews sit one page over. This is the way out.
    //
    // It has to be script rather than Liquid. The server-side test would be
    // product.metafields.reviews.rating_count, and that field is empty on
    // every product right now - the same gap that stops any product emitting
    // aggregateRating. Until Judge.me writes it, Liquid cannot tell an
    // unreviewed product from a reviewed one.
    //
    // Appended to the SECTION, not beside the widget: Judge.me's
    // .shopify-app-block wrapper computes to zero width, and a paragraph
    // dropped in there wrapped to one word per line.
    if (!more) {
      var p = document.createElement('p');
      p.className = 'tl-jm-more';
      p.innerHTML = '' +
        '<a href="/pages/reviews">Read what people say about the rest of the range</a>';
      emptySection.appendChild(p);
    }
  }
  function locatorPlaceholder(){
    var q = document.querySelector('.stockist-search-field');
    if (!q || q.dataset.tlPh) return;
    // Stockist ships "Type a postcode or address..." from its own config.
    q.setAttribute('placeholder', 'Your location');
    q.dataset.tlPh = 'Your location';
    q.addEventListener('focus', function(){ q.setAttribute('placeholder',''); });
    q.addEventListener('blur',  function(){ if (!q.value) q.setAttribute('placeholder', q.dataset.tlPh); });
  }
  /* Symmetry's footer section declares no `tag`, so Shopify wraps it in a
     plain <div> and the page ends up with no footer landmark - a screen
     reader user cannot jump to it. sections/footer.liquid is a Clean Canvas
     file, so `tag: "footer"` is not ours to add (rule 3).

     Doing it in script is reliable for the people it is for: NVDA, JAWS and
     VoiceOver all run inside real browsers with JavaScript enabled. This is
     not the same as relying on JS for content, which we do not do. */
  function footerLandmark(){
    var f = document.querySelector('.section-footer');
    if (f && !f.getAttribute('role')) f.setAttribute('role','contentinfo');
  }
  /* Copy written elsewhere sometimes opens each list item with a check
     mark, which then sits next to the list's own bullet - two markers for
     one item. Found on all three Hip + Joint products, 15 items.

     Detected by content rather than by selector, so it keeps working when
     the Gen-2 copy lands with the same habit, and it leaves ordinary
     bulleted lists alone. The mark stays; the bullet goes. */
  function checkLists(){
    document.querySelectorAll('li').forEach(function(li){
      if (li.dataset.tlChk) return;
      li.dataset.tlChk = '1';
      if (/^\s*[\u2713\u2714\u2705\u2611]/.test(li.textContent || '')) {
        var list = li.parentElement;
        if (list) list.classList.add('tl-checklist');
      }
    });
  }
  function run(){ fixHeading(); markEmptyReviews(); locatorPlaceholder(); footerLandmark(); checkLists(); }
  function start(){
    run();
    try{
      new MutationObserver(function(){ run(); }).observe(document.body, {childList:true, subtree:true});
    }catch(e){}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* ---- tl-preview-stick ---- */
(function(){
  var t = window.Shopify && window.Shopify.theme;
  if (!t || t.role === 'main' || !t.id) return;   // published theme: no-op
  var id = String(t.id);

  function decorate(a){
    try{
      var h = a.getAttribute('href');
      if (!h || /^(#|mailto:|tel:|javascript:)/i.test(h)) return;
      var u = new URL(h, location.origin);
      if (u.origin !== location.origin) return;
      if (/^\/checkouts?\//.test(u.pathname)) return;   // checkout is unthemed
      if (u.searchParams.get('preview_theme_id')) return;
      u.searchParams.set('preview_theme_id', id);
      a.setAttribute('href', u.pathname + u.search + u.hash);
    }catch(e){}
  }

  function sweep(){
    var as = document.querySelectorAll('a[href]');
    for (var i=0;i<as.length;i++) decorate(as[i]);
  }

  sweep();
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', sweep);

  // Links injected later: drawers, quick view, predictive search.
  document.addEventListener('click', function(e){
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (a) decorate(a);
  }, true);

  // Catch anything rendered after load without polling.
  if (window.MutationObserver){
    new MutationObserver(function(muts){
      for (var i=0;i<muts.length;i++){
        var ns = muts[i].addedNodes;
        for (var j=0;j<ns.length;j++){
          var n = ns[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'A') decorate(n);
          else if (n.querySelectorAll){
            var as = n.querySelectorAll('a[href]');
            for (var k=0;k<as.length;k++) decorate(as[k]);
          }
        }
      }
    }).observe(document.documentElement, {childList:true, subtree:true});
  }
})();

/* ---- tl-empty-link-a11y ---- */
/* Symmetry's blog card renders the article image as
     <a href="..."><div class="img-ar" style="--aspect-ratio: 0"></div></a>
   With no image resolved the anchor is 0x0 and completely empty, so it has no
   accessible name. Lighthouse fails it twice - "Links do not have a discernible
   name" (accessibility) and "Links do not have descriptive text" (SEO, -8 on the
   home page). It is also a duplicate: the very next anchor is the article title,
   pointing at the same URL.

   So the fix is to take the empty one out of the accessibility tree and the tab
   order rather than invent a label for it. Nothing is lost - the destination is
   still reachable by the title link and the "Read more" link beside it.

   The underlying cause is content: those cards should be showing a featured
   image. Raised separately; this stops it being an a11y and SEO defect
   in the meantime. */
(function(){
  function fix(){
    document.querySelectorAll('a[href]').forEach(function(a){
      if (a.getAttribute('aria-hidden') === 'true') return;
      if ((a.textContent || '').trim()) return;
      if (a.getAttribute('aria-label') || a.getAttribute('title')) return;
      if (a.querySelector('img, svg, [aria-label]')) return;
      if (a.getBoundingClientRect().height > 0) return;
      a.setAttribute('aria-hidden', 'true');
      a.setAttribute('tabindex', '-1');
    });
  }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', fix);
  else fix();
  window.addEventListener('load', fix);
})();

/* ---- descriptive "Read more" links (14 Sep 2026) ----
   Lighthouse SEO "Links do not have descriptive text" (-8 on the homepage):
   article cards end in a link whose visible text is just "Read more". The
   aria-label already names the article, but link-text audits and many
   crawlers read the text content. Append the article title as visually hidden
   text, so the link reads "Read more about <title>" to machines while the
   brand CTA stays "Read more" on screen. Title comes from the aria-label the
   theme already renders ("Read more: <title>"), else the card's own heading. */
(function(){
  function fix(){
    document.querySelectorAll('a').forEach(function(a){
      if (a.getAttribute('data-tl-rm')) return;
      var t = (a.textContent || '').trim().toLowerCase();
      if (t !== 'read more') return;
      var title = '';
      var al = a.getAttribute('aria-label') || '';
      if (/^read more:\s*/i.test(al)) title = al.replace(/^read more:\s*/i, '');
      if (!title){
        var card = a.closest('.article, .article__inner, .blog-post, article');
        var h = card && card.querySelector('h2, h3, h4');
        if (h) title = h.textContent.trim();
      }
      if (!title) return;
      a.setAttribute('data-tl-rm', '1');
      var s = document.createElement('span');
      s.className = 'visually-hidden';
      s.textContent = ' about ' + title;
      a.appendChild(s);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix); else fix();
})();

/* ------------------------------------------------------------------
   RANGE PROOF ON A PRODUCT WITH NO REVIEWS OF ITS OWN

   A product with no reviews showed an empty shelf: a be-the-first line
   and a link. Nine of 24 products are in that state, and they include
   every bundle and 2-Pack, which are the highest priced items on the
   site. The range's own record is the honest thing to put there.

   The numbers are read from the .tl-revtot line the page already
   renders, so there is one source of truth and nothing is hardcoded.
   That line is then hidden by CSS, via the body class set below, so the
   figure appears once on the page rather than twice.

   DISPLAY ONLY. None of this is marked up. Google's review snippet rule
   is to mark up a specific item, not a category or a list, so a product
   with no reviews of its own must keep emitting no aggregateRating.
   Verified 17 Sep: no-review products emit ProductGroup with no rating,
   reviewed ones emit their own. Never wire these numbers into markup.

   The label 'from N reviews across the range' is load bearing. Without
   it a 4.8 on a product with no reviews claims something untrue. Do not
   shorten it.
   ------------------------------------------------------------------ */
(function(){
  function build(){
    var host = document.querySelector('.tl-jm-empty');
    if(!host) return false;
    if(host.querySelector('.tl-jm-proof')) return true;
    var src = document.querySelector('.tl-revtot');
    if(!src) return false;
    var n = src.querySelectorAll('.tl-revtot__n');
    if(n.length < 2) return false;
    var score = n[0].textContent.trim();
    var count = n[1].textContent.trim();
    if(!score || !count) return false;
    var link = src.querySelector('a');
    var href = link ? link.getAttribute('href') : '/pages/reviews';
    var on = Math.round(parseFloat(score)) || 5;
    var stars = '';
    for(var i=1;i<=5;i++){ stars += '<span class="tl-jm-proof__star' + (i<=on ? ' is-on' : '') + '">\u2605</span>'; }
    var a = document.createElement('a');
    a.className = 'tl-jm-proof';
    a.href = href;
    a.innerHTML =
      '<p class="tl-jm-proof__stars" aria-hidden="true">' + stars + '</p>' +
      '<p class="tl-jm-proof__n"><strong>' + score + '</strong><span class="tl-jm-proof__of"> out of 5</span></p>' +
      '<p class="tl-jm-proof__c">from ' + count + ' reviews across the range</p>' +
      '<span class="tl-jm-proof__cta">Read all reviews</span>';
    host.insertBefore(a, host.firstChild);
    /* the proof carries the link now, so the plain one below would say it twice */
    var more = host.querySelector('.tl-jm-more');
    if(more) more.style.display = 'none';
    document.body.classList.add('tl-no-reviews');
    return true;
  }
  /* Judge.me renders late, so poll for a short window rather than racing it */
  var tries = 0;
  var timer = setInterval(function(){ if(build() || ++tries > 40) clearInterval(timer); }, 250);
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', build); } else { build(); }
})();

/* tl-gallery-warm: the theme setting preload_pdp_gallery_images is off, so only the
   first gallery slide loads with the page and the LCP image gets fetchpriority high.
   Once the page is idle we promote the remaining slides back to eager so the carousel,
   the thumbnails and the variant swatches behave exactly as they did before. Any
   shopper interaction with the gallery or the variant picker promotes them at once. */
(function () {
  var done = false;

  function promote() {
    if (done) return;
    done = true;
    var galleries = document.querySelectorAll("media-gallery");
    for (var g = 0; g < galleries.length; g++) {
      var imgs = galleries[g].querySelectorAll('img[loading="lazy"]');
      for (var i = 0; i < imgs.length; i++) {
        try {
          imgs[i].loading = "eager";
          imgs[i].setAttribute("loading", "eager");
        } catch (e) {}
      }
    }
  }

  function schedule() {
    if (window.requestIdleCallback) { requestIdleCallback(promote, { timeout: 2500 }); }
    else { setTimeout(promote, 1200); }
  }

  if (document.readyState === "complete") { setTimeout(schedule, 600); }
  else { window.addEventListener("load", function () { setTimeout(schedule, 600); }); }

  var sel = "media-gallery, variant-picker, .variant-picker, .product-info, .swatch, .thumbnails";
  ["pointerdown", "keydown", "touchstart"].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (done) return;
      var t = e.target;
      if (t && t.closest && t.closest(sel)) promote();
    }, { passive: true, capture: true });
  });
})();
